import {Link} from 'react-router-dom';
import '../Projects/ProjectArticle.css';
import './Career.css';
import Button from '../components/Button';



const Career = () => {
    return (
        <div>
            <section className="project-hero Career">
                <div className="project-name">
                    <h2>Careers</h2>
                </div>
            </section>

            <section className="careers-section">
                
                <div className="career-description">
                    <h3>Current Opening</h3>
                    
                    <p className="subtext">
                        {/* FILL WHEN CONTENT IS AVAILABLE */}
                    </p>
                </div>

                <div className="open-positions">
                    <h3 className='career-heading'>CALL FOR APPLICATION - Field Enumerators</h3>
                    <div className="open-position">
                        <p>
                            The Green Environment and Climate Change Initiative (GRENCHI) is seeking the expertise of Field Enumerators to collect socio-economic and farm-level data from farming households in Awka, Anambra State.
                        </p>
                        <h4 className="about-position bold">About the Role</h4>

                        <p>
                            Successful applicants will play a vital role in the implementation of a community development project by supporting field data collection activities. Field Enumerators will administer structured questionnaires and conduct interviews with targeted community households.
                            <br />
                            <br />
                            Candidates must demonstrate professionalism, integrity and ethical conduct when engaging with participants. Accuracy, confidentiality, and attention to detail are essential, as the findings from this survey will inform a project engagement strategy.
                        </p>

                        <h4 className="about-position bold">The Field Enumerator Key Responsibilities</h4>

                        <ul>
                            <li>Attend a one-day enumerator training session organized by GRENCHI before survey deployment</li>
                            <li>Administer the structured questionnaire to the intended groups</li>
                            <li>Conduct surveys in Igbo language with clarity, respect and cultural sensitivity</li>
                            <li>Ensure accurate, complete, and timely data collection and submission</li>
                            <li>Adhere strictly to all protocols and project guidelines</li>
                            <li>Maintain confidentiality and uphold data protection standards throughout the survey</li>
                            <li>Attend daily debrief sessions with the Officer in-charge to review data quality and resolve any issues</li>
                            <li>Complete the survey assignment within the agreed timeframe - approximately 10 working days</li>
                        </ul>

                        <h4 className="about-position bold">Eligibility Requirements</h4>
                        <p>Interested applicants must possess the following:</p>
                        <ul>
                            <li>Minimum qualification of OND, NCE, HND, or Bachelor’s Degree.</li>
                            <li>Previous experience in field research, survey administration, or data collection will be an added advantage.</li>
                            <li>Excellent communication and interpersonal skills.</li>
                            <li>Ability to work independently and collaboratively within a team.</li>
                            <li>Willingness to undertake field assignments and meet project timelines.</li>
                            <li>Basic knowledge of ethical research practices, especially when working with communities.</li>
                        </ul>

                        <h4 className="about-position bold">Who Should Apply?</h4>
                        <p>This opportunity is ideal for:</p>
                        <ul>
                            <li>Field Enumerators</li>
                            <li>Data Collectors</li>
                            <li>Community Development Practitioners</li>
                            <li>Youth in Agriculture</li>
                            <li>Early-career graduates seeking practical research experience</li>
                        </ul>

                        <h4 className="bold">Method of Application</h4>
                        <p>
                            Interested and qualified candidates should apply through the application link. Application received through email will not be considered.
                            <br />
                            <br />
                            Applicants are advised to complete the application form carefully and provide accurate information. Only shortlisted candidates will be contacted for the next stage of the recruitment process.
                        </p>

                        <p><span className='bold'>Deadline:</span> 25th October 2026</p>

                        <div 
                            className="open-position-link"
                            style={{
                                marginTop: "30px"
                            }}
                        >
                            <Link to="https://docs.google.com/forms/d/e/1FAIpQLSf_uo5bjFgT0I1eFxblQbb1B9qaE41fzDIjA5ejeDoVXDow1g/viewform?usp=sharing&ouid=115063193720750694162" target="_blank"><Button className='open-position-button'>Click here to Apply</Button></Link>
                        </div>
                    </div>
                </div>
                

                {/* CLOSED POSITIONS */}
                <div className="closed-positions">
                    <h3>Closed</h3>
                    <div className="open-positions-list">
                        <div className="open-position">
                            <h4 className="title">Project Coordinator</h4>

                            <p className="description">We are looking to recruit an experienced, field-ready, results-driven Project Coordinator  to lead the planning, implementation, coordination and reporting of GRENCHI's field and community-based projects. This is a mid-level role for someone who can manage multiple work streams, partners, team member, volunteers and deadlines at once.</p>

                            <div className="open-position-link">
                                <Link className='link' to="https://drive.google.com/file/d/1YQ1uXsnUjPod4KzHVxJV6_H9KzI-jPYQ/view?usp=drive_link" target="_blank">Click here for Role Description</Link>
                            
                                <Link to="https://docs.google.com/forms/d/e/1FAIpQLSe5whkPhybU3YRzkg_m-PBkoP6u6_xZpYgDz4t6_9thdzAn-w/viewform?usp=sharing&ouid=115063193720750694162" target="_blank"><Button className='open-position-button'>Click here to Apply</Button></Link>
                            </div>

                            
                        </div>

                        <div className="open-position">
                            <h4 className="title">Finance Officer</h4>

                            <p className="description">The ideal candidate will be a diligent, detail-oriented person who would manage GRENCHI's day-to-day financial operations. From bookkeeping and budget monitoring to statutory tax compliance and donor financial reporting. This role requires strong working knowledge of Nigerian tax administration, particularly FIRS filings and the ability to keep our books audit-ready across multiple funded projects.</p>

                            <div className="open-position-link">
                                <Link className='link' to="https://drive.google.com/file/d/1SvfOJruWg9dQwQOU-G1VgmtTrts5Jbek/view?usp=drive_link" target="_blank">Click here for Role Description</Link>
                            
                                <Link to="https://docs.google.com/forms/d/e/1FAIpQLSfy6GFXpkcOeKZwEKoxLxEhLmJiFA9ALwUGTcLOEoEE8gSwvA/viewform?usp=sharing&ouid=115063193720750694162" target="_blank"><Button className='open-position-button'>Click here to Apply</Button></Link>
                            </div>
                        </div>

                        <div className="open-position">
                            <h4 className="title">Communications and Media Officer</h4>

                            <p className="description">We're recruiting for a creative, strategic Communications and Media Officer to grow GRENCHI's public voice and advance our advocacy agenda. You'll lead our storytelling, manage our digital presence and help drive engagement with government and institutional partners on climate and environmental policy.</p>

                            <div className="open-position-link">
                                <Link className='link' to="https://drive.google.com/file/d/129Z575Htoq6gv3U-yDLTrjrVoVKQMgcj/view?usp=sharing" target="_blank">Click here for Role Description</Link>
                            
                                <Link to="https://docs.google.com/forms/d/e/1FAIpQLSfY4mwUaHkXUy4qfw2GMAiL2H0yEHG5nNJe1y1KtVY3DIgYNw/viewform?usp=sharing&ouid=115063193720750694162" target="_blank"><Button className='open-position-button'>Click here to Apply</Button></Link>
                            </div>
                        </div>

                        <div className="open-position">
                            <h4 className="title">Community Engagement and Advocacy Officer</h4>

                            <p className="description">We seek a field-ready, warm, trusted and a highly organized Community Engagement and Advocacy Officer to be the face of GRENCHI in the communities where we work and lead advocacy.</p>

                            <div className="open-position-link">
                                <Link className='link' to="https://drive.google.com/file/d/1qkMVBD9VSkzMswDbTpJZOZAFqWms_Fon/view?usp=sharing" target="_blank">Click here for Role Description</Link>
                            
                                <Link to="https://docs.google.com/forms/d/e/1FAIpQLScdRDNXdb3mvS9aX77rdnQQBJG8DJKURfhQxnUhL0NzDh3ZJw/viewform?usp=sharing&ouid=115063193720750694162" target="_blank"><Button className='open-position-button'>Click here to Apply</Button></Link>
                            </div>
                        </div>

                        <div className="open-position">
                            <h4 className="title">Field Operations & Restoration Officer</h4>

                            <p className="description">We're looking for a practical, field-ready Officer who personally leads and carries out all our field work. This role is hands-on, so it requires you to roll your sleeves.</p>

                            <div className="open-position-link">
                                <Link className='link' to="https://drive.google.com/file/d/1Yb3UZDDJXX5-rMVnAkkLgbG_8GmM4pIC/view?usp=sharing" target="_blank">Click here for Role Description</Link>
                            
                                <Link to="https://docs.google.com/forms/d/e/1FAIpQLScBViiHsH4-LOk3kXK13fXAmH6Sd5SwN5lKjo2LTmoBNuh_aA/viewform?usp=sharing&ouid=115063193720750694162" target="_blank"><Button className='open-position-button'>Click here to Apply</Button></Link>
                            </div>
                        </div>

                        <div className="open-position">
                            <h4 className="title">Field Assistants</h4>

                            <p className="description">We're recruiting multiple Field Assistants to provide the flexible, day-to-day hands that keep all our field work running smoothly.</p>

                            <div className="open-position-link">
                                <Link className='link' to="https://drive.google.com/file/d/1mQsN90PB5aFFcOXSqUDcjevBuJ7L1pCH/view?usp=sharing" target="_blank">Click here for Role Description</Link>
                            
                                <Link to="https://docs.google.com/forms/d/e/1FAIpQLSfqNpAJUijepDFGftxaW9jdrcgVYWmyxVBMlfytTDbQoILYYg/viewform?usp=sharing&ouid=115063193720750694162" target="_blank"><Button className='open-position-button'>Click here to Apply</Button></Link>
                            </div>
                        </div>

                    </div>
                </div>
                
                <p style={{marginTop: "25px"}}>
                    We are an equal opportunity employer and encourages qualified candidates of all backgrounds to apply.
                    <br />
                    Applications are reviewed on a rolling basis.
                </p>
                
            </section>
        </div>
    )
}

export default Career